import { template as template_83d2ceaeed3446e492a1108b6d809802 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import CardError from '@cardstack/host/components/card-error';
import type { ErrorModel as IndexRouteErrorModel } from '@cardstack/host/routes/index';
interface Signature {
    Args: {
        model: IndexRouteErrorModel;
    };
}
const IndexErrorRouteComponent: TemplateOnlyComponent<Signature> = template_83d2ceaeed3446e492a1108b6d809802(`
  <CardError
    @type={{@model.loadType}}
    @message={{@model.message}}
    @operatorModeState={{@model.operatorModeState}}
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(IndexErrorRouteComponent);
